import DelayRepayService from '../services/DelayRepayService';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import CustomerActions from '../actions/CustomerActions';
import FeatureFlagStore from '../stores/FeatureFlagStore';


const DelayRepayActions = {
    async subscribe(user, notifyByPreference) {
        try {
            await DelayRepayService.subscribe(user, notifyByPreference);

            const enableInAppTokenRefreshOnPageLoad = FeatureFlagStore.get('enableInAppTokenRefreshOnPageLoad');

            // Get the updated user who is now subscribed to OCDR
            await CustomerActions.refresh(user, enableInAppTokenRefreshOnPageLoad);

            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_SUBSCRIBE_SUCCESS,
            });
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_SUBSCRIBE_FAILURE,
            });
        }
    },

    async unsubscribe(user) {
        try {
            const response = await DelayRepayService.unsubscribe(user.id);

            const enableInAppTokenRefreshOnPageLoad = FeatureFlagStore.get('enableInAppTokenRefreshOnPageLoad');

            // Get the updated user who is now unsubscribed from OCDR
            await CustomerActions.refresh(user, enableInAppTokenRefreshOnPageLoad);

            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_UNSUBSCRIBE_SUCCESS,
            });
            return response;
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_UNSUBSCRIBE_FAILURE,
            });
            return false;
        }
    },

    async updateSubscription(user, notifyByPreference) {
        try {
            await DelayRepayService.subscribe(user, notifyByPreference);

            const enableInAppTokenRefreshOnPageLoad = FeatureFlagStore.get('enableInAppTokenRefreshOnPageLoad');

            // Get the updated user who is now subscribed to OCDR
            await CustomerActions.refresh(user, enableInAppTokenRefreshOnPageLoad);

            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_UPDATE_SUBSCRIPTION_SUCCESS,
            });
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.USER_OCDR_UPDATE_SUBSCRIPTION_FAILURE,
            });
        }
    },
};

export default DelayRepayActions;



// WEBPACK FOOTER //
// ./src/actions/DelayRepayActions.js